import React from 'react';
import { ContactCrisis } from './common';

export const incidentSupportText = (
  <div>
    <p>
      If you need to take a break from the process, your responses are being
      saved and will be here when you return to your online application.
    </p>
    <ContactCrisis />
  </div>
);
